import { injectHubSpotScript } from '../helpers'
const productTabs = () => {
	let hubspotProductTab = document.querySelector('.js-tabhubspot--trigger')
	if (hubspotProductTab) {
		let hubspotProductTabContent = document.querySelector('#tabHubspot .hubspot--form')
		const queryString = window.location.search
		const urlParams = new URLSearchParams(queryString);
		const tabValue = urlParams.get('tab')

		// inject form on page load when tab parameter is in url
		if(tabValue == 'tabHubspot') {
			injectHubSpotScript(hubspotProductTabContent)
		}

		// handle tab click event to load form
		hubspotProductTab.addEventListener('click', (e) => {
			injectHubSpotScript(hubspotProductTabContent)
		})
	}
}
export default productTabs
